import { useTheme } from '@doxyme/ui-foundation/theme';
import { type CSSObject } from '@emotion/react';
import { Specs } from '@doxyme/extensions-bridge-react';

import Variant = Specs.OverlayApplet.Variant;

export function useExtensionsOverlayAppletStyles(variant?: Variant): {
  container: CSSObject;
} {
  const theme = useTheme();

  return {
    container: {
      display: 'flex',
      height: '100%',
      width: '100%',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: theme.zIndex.modal,
      backgroundColor: 'transparent',
      justifyContent: 'center',
      alignItems: 'center',
      // Modal Variant Styles
      ...(variant === Variant.Modal && {
        backgroundColor: theme.background.dimmingLayer,
      }),
    },
  };
}
